import React, { Component } from 'react'
import PropTypes from "prop-types"
import {getURL} from '../Utils'
import {Panel} from 'react-bootstrap'
import ImmutablePropTypes from 'react-immutable-proptypes';
import GameInformation from './GameInformation'
import LaunchOptions from './LaunchOptions'
import URLLaunchOptions from './URLLaunchOptions'

import {CopyToClipboard} from 'react-copy-to-clipboard';
import { AlertList } from "react-bs-notifier";

export default class MoreDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
			position: "top-right",
			alerts: [],
			timeout: 1000,
      newMessage: "",
      url : getURL() + "/env/?launch-game=" + this.props.game.get("game")
		};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.game.get('game') !== this.props.game.get("game")) {
      this.setState({
        url : getURL() + "/env/?launch-game=" + nextProps.game.get("game")
      })
    }
  }

  generate() {
    const newAlert ={
      id: (new Date()).getTime(),
      type: "success",
      headline: "Success",
    //  timeout: 1000,
      message: this.state.url+" copied to clipboard"
    };

    this.setState({
      alerts: [...this.state.alerts, newAlert]
    });
  }

  onAlertDismissed(alert) {
    const alerts = this.state.alerts;

    // find the index of the alert that was dismissed
    const idx = alerts.indexOf(alert);

    if (idx >= 0) {
      this.setState({
        // remove the alert from the array
        alerts: [...alerts.slice(0, idx), ...alerts.slice(idx + 1)]
      });
    }
  }

  render () {
    return (
      <div className="col-xs-12">
        <AlertList
          position={this.state.position}
          alerts={this.state.alerts}
          timeout={this.state.timeout}
          onDismiss={this.onAlertDismissed.bind(this)}
        				/>

        <Panel collapsible expanded={this.props.open} className="col-xs-12">
          <div className="col-xs-4">
            <div className="col-xs-12 well well-sm">
              Link to launch automatically:<p className="text-primary"> {this.state.url} </p>
            <CopyToClipboard text={this.state.url} onCopy={this.generate.bind(this)}>
              <button className="btn btn-info btn-block">Copy to clipboard</button>
            </CopyToClipboard>
            </div>
          </div>

          <div className="col-xs-8">
            <div className="col-xs-12">
              <GameInformation gameInfo={this.props.game}/>
            </div>

            <div className="col-xs-12" >
              <LaunchOptions gameInfo={this.props.game} config={this.props.config} launchOptions={this.props.launchOptions}/>
            </div>

            <div className="col-xs-12" >
              <URLLaunchOptions gameInfo={this.props.game} config={this.props.config} launchOptions={this.props.launchOptions} urlLaunchOptions={this.props.urlLaunchOptions}/>
            </div>
          </div>
        </Panel>
      </div>
    )
  }
}

MoreDetails.propTypes = {
  game: ImmutablePropTypes.map,
  config: ImmutablePropTypes.map,
  open: PropTypes.bool,
  launchOptions : ImmutablePropTypes.map,
  urlLaunchOptions: ImmutablePropTypes.map
}



// WEBPACK FOOTER //
// ./src/components/MoreDetails.js